import React from 'react';

import {
  SubtitleSecondary,
  Paragraph,
  FormProviderNewService,
} from '@components/index';

import { Container, Group } from './styles';

interface IProps {
  myStep: number;
  currentStep: number;
  changeStep(newStep: number, willChangeHistory?: boolean): void;
}

const StepService: React.FC<IProps> = ({ currentStep, changeStep }) => {
  return (
    <Container>
      <SubtitleSecondary textAlign="start" nameColor="black">
        Serviços
      </SubtitleSecondary>
      <Paragraph
        textAlign="start"
        nameColor="black"
        opacity={0.5}
        fontWeight={500}
      >
        Cadastre um ou mais serviços disponíveis
      </Paragraph>
      <Group>
        <FormProviderNewService
          forNewProviderService={{
            advanceStep: () => {
              changeStep(currentStep + 1);
            },
          }}
        />
      </Group>
    </Container>
  );
};

export default StepService;
